import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ReactVideoModal from "./ReactVideoModal/ReactVideoModal";

class InlineModalVideoPortal extends Component {

    static propTypes = {
        videoUrl: PropTypes.string.isRequired,
        // eslint-disable-next-line react/forbid-prop-types,react/no-unused-prop-types
        videoId: PropTypes.object.isRequired,
        isOpen: PropTypes.bool,
        handleClose: PropTypes.func.isRequired
    };

    static defaultProps = {
        isOpen: false
    };

    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        document.getElementById('app').appendChild(this.el);
    }

    componentWillUnmount() {
        document.getElementById('app').removeChild(this.el);
    }

    render() {
        const {isOpen, handleClose} = this.props;

        return ReactDOM.createPortal(
            <ReactVideoModal uri={this.props.videoUrl} inline={false} isOpen={isOpen} onClose={() => handleClose()}/>,
            this.el
        );
    }

}

export default InlineModalVideoPortal;



// WEBPACK FOOTER //
// ./frontend/components/InlineModalVideoPortal.jsx